import React from "react";
import style from "./App.module.scss";
import { Message } from "@messageformat/react";

const ContactIframe = () => {
  return (
    <a
      href="https://eepurl.com/i1SNeA"
      className={style.cta}
    >
      <Message id="contactForm.cta" />
    </a>
  );
};

export default ContactIframe;
